import { Link } from 'react-router-dom'
import styles from './Header.module.css'
const Header = () => {
  return (
    <header className={styles.header}>
      <div className={styles.left}>
        <Link to='/'>
          <h4>PIOTR OPALA</h4>
        </Link>
      </div>
      <div className={styles.right}>
        <a href='mailto: piotropala.music@gmail.com'>
          <p>piotropala.music@gmail.com</p>
        </a>
      </div>
    </header>
  )
}

export default Header
